export default __webpack_public_path__ + "static/media/vision.3f5390ee.png";